import styled from 'styled-components'

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: ${props => props.theme.colors.text.primary};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
